import { Erfahrungslevel } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/erfahrungslevel';
import {
  faEllipsis,
  faStar,
  faStarHalf,
  IconDefinition,
} from '@fortawesome/pro-regular-svg-icons';
import { faStar as faStarSolid } from '@fortawesome/pro-solid-svg-icons';
import { useTranslation } from 'react-i18next';

export function useErfahrungslevelOptions(): {
  key: Erfahrungslevel;
  name: string;
  icon: IconDefinition;
}[] {
  const { t } = useTranslation();
  return [
    {
      key: 'keineBewertung',
      name: t(
        'domain.mitarbeiter.create.steps.person.arbeitsbereiche.form.erfahrungslevel.options.KeineBewertung',
      ),
      icon: faEllipsis,
    },
    {
      key: 'Anfaenger',
      name: t(
        'domain.mitarbeiter.create.steps.person.arbeitsbereiche.form.erfahrungslevel.options.Anfaenger',
      ),
      icon: faStarHalf,
    },
    {
      key: 'Fortgeschrittener',
      name: t(
        'domain.mitarbeiter.create.steps.person.arbeitsbereiche.form.erfahrungslevel.options.Fortgeschrittener',
      ),
      icon: faStar,
    },
    {
      key: 'AlterHase',
      name: t(
        'domain.mitarbeiter.create.steps.person.arbeitsbereiche.form.erfahrungslevel.options.AlterHase',
      ),
      icon: faStarSolid,
    },
  ];
}
